import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-page container my-8">
      <h1 className="text-center text-primary">Contact Us</h1>
      <p className="text-center">We'd love to hear from you! Reach out with any questions or feedback.</p>

      <div className="contact-form-section shadow-md rounded-lg p-6">
        <form>
          <div className="form-group">
            <label htmlFor="name">Your Name:</label>
            <input type="text" id="name" className="form-control" placeholder="Enter your name" />
          </div>
          <div className="form-group">
            <label htmlFor="email">Your Email:</label>
            <input type="email" id="email" className="form-control" placeholder="Enter your email" />
          </div>
          <div className="form-group">
            <label htmlFor="message">Your Message:</label>
            <textarea id="message" className="form-control" rows="5" placeholder="Type your message here"></textarea>
          </div>
          <button type="submit" className="btn btn-primary">Send Message</button>
        </form>
      </div>

      <div className="contact-info-section text-center my-8">
        <h2>Our Details</h2>
        <p><strong>Email:</strong> info@tweelabs.com</p>
        <p><strong>Website:</strong> <a href="https://tweelabs.com" target="_blank" rel="noopener noreferrer">tweelabs.com</a></p>
        <p><strong>Address:</strong> [Your Company Address Here - Optional]</p>
      </div>
    </div>
  );
}

export default Contact;
